import {eq} from '@shared/helpers/lang'
import {qs} from '@shared/helpers/queryString'

import {Badge, Badges, DELIVERY_MANAGE_SCENE, DeliveryManagerSceneType} from '@web/core/constants'
import {ROUTER_ORDER_DELIVERY} from '@web/core/routes'
import {
    changeDeliveryInfoCase,
    DELIVERY_MANAGER_TYPE,
    DeliveryManagerType,
    SELECT_ADDRESS_SUBTYPE,
    SELECT_DELIVERY_ADDRESS_SUBTYPE,
    SELECT_DELIVERY_INFO_SUBTYPE,
} from '@web/slices/deliveryManager/slice'

import {confirmAddressForm, selectDeliveryAddress} from '../deliveryAddress'
import {sendZipCodeResult} from '../zipcode'

export const SaveAddressType = {
    /** 신규 입력 */
    ADD: 'ADD',
    /** 수정 */
    EDIT: 'EDIT',
    /** 저장 */
    REGISTER: 'REGISTER',
}

export const getSaveAddressType = (addressIdentifier?: {hash: string; isRegistered: boolean}) => {
    if (!addressIdentifier?.hash) {
        return SaveAddressType.ADD
    }
    return addressIdentifier.isRegistered ? SaveAddressType.EDIT : SaveAddressType.REGISTER
}

export const increaseHistoryCountFromBase = (historyCountFromBase: number | undefined = 0) => historyCountFromBase + 1

type SendIframePostmessageProp = {
    key: string
    content: Maybe<{
        baseAddress: string
        detailAddress: string
        isRoadNameAddress: boolean
        numberOfLotAddress: string
        roadNameAddress: string
        zipcode: string
    }>
}

// 우편번호 검색 성공시 content에 검색 결과를, X버튼 클릭시 null로 전송
export const sendIframePostmessage = ({key, content}: SendIframePostmessageProp) => {
    window.parent.postMessage(
        {
            type: key,
            content,
        },
        '*',
    )
}

// 배송지변경창 타입으로 최초 scene 결정
export const getInitialSceneWithType = (type: DeliveryManagerType): DeliveryManagerSceneType => {
    const searchSceneInitType = [
        SELECT_ADDRESS_SUBTYPE.SELECT_ADDRESS_NORMAL,
        SELECT_DELIVERY_ADDRESS_SUBTYPE.CORRECT_INVALID_DELIVERY_ADDRESS,
        SELECT_DELIVERY_ADDRESS_SUBTYPE.ADD_FIRST_ADDRESS,
    ]
    const formSceneInitType = [SELECT_DELIVERY_INFO_SUBTYPE.CHANGE_CONTACT_ONLY]
    const listSceneInitType = [
        SELECT_DELIVERY_ADDRESS_SUBTYPE.SELECT_DELIVERY_ADDRESS_NORMAL,
        SELECT_DELIVERY_ADDRESS_SUBTYPE.SELECT_DELIVERY_ADDRESS_NO_HASH,
    ]
    const changeSceneInitType = [
        SELECT_DELIVERY_INFO_SUBTYPE.SELECT_DELIVERY_INFO_NORMAL,
        SELECT_DELIVERY_INFO_SUBTYPE.SHOW_MEMO_FIRST,
    ]

    if (searchSceneInitType.some(eq(type))) {
        return DELIVERY_MANAGE_SCENE.SEARCH
    } else if (listSceneInitType.some(eq(type))) {
        return DELIVERY_MANAGE_SCENE.LIST
    } else if (formSceneInitType.some(eq(type))) {
        return DELIVERY_MANAGE_SCENE.FORM
    } else if (changeSceneInitType.some(eq(type))) {
        return DELIVERY_MANAGE_SCENE.CHANGE
    } else {
        return DELIVERY_MANAGE_SCENE.SEARCH
    }
}

export const getDeliveryManagerUrl = (type: DeliveryManagerType, isSubscription: boolean, seqID?: string) => {
    const isResultCase = changeDeliveryInfoCase.includes(type)

    let url = ''

    /** 자동결제 이용 서비스가 늘어날 시 or 조건으로 추가 */
    const isScheduledOrderDeliveryChange = isSubscription

    if (isResultCase) {
        url = isScheduledOrderDeliveryChange
            ? `${ROUTER_ORDER_DELIVERY.DELIVERY_SCHEDULED_ORDER_RESULT}/${seqID}`
            : `${ROUTER_ORDER_DELIVERY.DELIVERY}/${seqID}`
    } else {
        url = ROUTER_ORDER_DELIVERY.DELIVERY
    }

    return qs.inject({url, query: {internal: 'true'}})
}

/** 배송지명이 디폴트 뱃지와 일치하면 해당 뱃지가 체크된상태. */
export const getDeliveryAddressBadge = (deliveryAddressName: string): Maybe<Badge> => {
    if (!deliveryAddressName) {
        return null
    } else {
        return Badges.some((badge) => badge === deliveryAddressName) ? (deliveryAddressName as Badge) : '직접입력'
    }
}

/** 액션 종료 여부 판단. EndConditions 참고 */
export const checkDoneCondition = ({actionType, openType}: {actionType: string; openType: DeliveryManagerType}) => {
    // 액션별 배송지변경창 종료가 필요한 오픈타입들. value 배열에 포함된 오픈타입으로 열렸다면, key 액션에서 배송지변경창이 종료되어야 함.
    const EndConditions = {
        [sendZipCodeResult.typePrefix]: [DELIVERY_MANAGER_TYPE.SELECT_ADDRESS_NORMAL],
        [confirmAddressForm.typePrefix]: [
            DELIVERY_MANAGER_TYPE.ADD_FIRST_ADDRESS,
            DELIVERY_MANAGER_TYPE.CORRECT_INVALID_DELIVERY_ADDRESS,
            DELIVERY_MANAGER_TYPE.CHANGE_CONTACT_ONLY,
        ],
        [selectDeliveryAddress.typePrefix]: [
            DELIVERY_MANAGER_TYPE.SELECT_DELIVERY_ADDRESS_NORMAL,
            DELIVERY_MANAGER_TYPE.SELECT_DELIVERY_ADDRESS_NO_HASH,
        ],
    }

    const actionName = actionType.replace('/fulfilled', '')
    const endCondition = EndConditions[actionName] || []

    return endCondition.some(eq(openType))
}
